// assets/edm-bundle-analytics.js
// Tracking-Events (GA4, DataLayer) - damit der Business-Logik-Code sauber bleibt

window.EdumonBundle = window.EdumonBundle || {};

window.EdumonBundle.Analytics = {
  /**
   * Main tracking function - GA4 (gtag) + GTM (dataLayer)
   * Context7: Performance - Analytics never block main thread
   * 
   * @param {string} name - Event name
   * @param {Object} params - Event parameters
   */
  track: function(name, params = {}) {
    const sendEvent = () => {
      // GTM
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: `bb_${name}`, ...params });
      }
      // GA4 gtag.js
      if (typeof window.gtag === 'function') {
        window.gtag('event', `bb_${name}`, params);
      }
    };
    
    // Use requestIdleCallback if available to avoid blocking main thread
    if ('requestIdleCallback' in window) {
      requestIdleCallback(sendEvent, { timeout: 2000 });
    } else {
      // Fallback: Use setTimeout with 0 delay for non-critical browsers
      setTimeout(sendEvent, 0);
    }
  },
  
  /**
   * Track sheet open event
   * @param {Object} params - Additional parameters (e.g., {source: 'cta'})
   */
  trackSheetOpen: function(params = {}) {
    this.track('sheet_open', params);
  },
  
  /**
   * Track sheet close event
   * @param {Object} params - Additional parameters (e.g., {totalQty: 5})
   */
  trackSheetClose: function(params = {}) {
    this.track('sheet_close', params);
  },
  
  /**
   * Track quantity change event
   * @param {string} variantId - Variant ID
   * @param {number} delta - Change amount (+1 or -1)
   * @param {number} qty - New quantity
   */
  trackQtyChange: function(variantId, delta, qty) {
    this.track('qty_change', {
      variant_id: variantId,
      delta: delta,
      qty: qty
    });
  },
  
  /**
   * Track commit event
   * @param {number} totalQty - Total quantity
   * @param {number} tierOff - Tier discount percentage
   */
  trackCommit: function(totalQty, tierOff) {
    this.track('commit', {
      totalQty: totalQty,
      tier_off: tierOff
    });
  },
  
  /**
   * Track reset event
   */
  trackReset: function() {
    this.track('reset');
  },
  
  /**
   * Track tier reached event
   * @param {number} qty - Quantity threshold
   * @param {number} off - Discount percentage
   */
  trackTierReached: function(qty, off) {
    this.track('tier_reached', {
      qty: qty,
      off: off
    });
  }
};

// Backward compatibility: Export bbTrack as alias
window.bbTrack = function(name, params) {
  window.EdumonBundle.Analytics.track(name, params);
};

